import ServicePageTemplate from '../ServicePageTemplate';

const ASSETS = {
  remodeling: "https://images.pexels.com/photos/10827349/pexels-photo-10827349.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

const RemodelingService = () => {
  return (
    <ServicePageTemplate
      title="Remodeling"
      subtitle="Kitchen & Bath Renovations"
      image={ASSETS.remodeling}
      description="Transform your kitchen or bathroom with BNPH's expert remodeling services. We handle all plumbing aspects of your renovation, from relocating pipes to installing new fixtures. Our team works with your contractor or directly with you to bring your vision to life."
      features={[
        'Complete bathroom remodeling plumbing',
        'Kitchen renovation specialists',
        'Older home expertise',
        'Fixture selection assistance',
        'Code compliance assured',
        'Project coordination with contractors',
      ]}
      services={[
        'Bathroom Remodeling',
        'Kitchen Remodeling',
        'Fixture Installation',
        'Pipe Relocation',
        'New Construction Plumbing',
        'Shower Installation',
        'Bathtub Installation',
        'Vanity Installation',
        'Kitchen Sink Installation',
        'Dishwasher Installation',
        'Garbage Disposal',
        'Water Line Relocation',
      ]}
      relatedServices={[
        { title: 'Residential', link: '/services/residential', description: 'Complete home plumbing services.' },
        { title: 'Water Heaters', link: '/services/water-heaters', description: 'Upgrade your water heater during remodel.' },
        { title: 'Commercial', link: '/services/commercial', description: 'Commercial renovation projects.' },
      ]}
    />
  );
};

export default RemodelingService;
